export default function SortIcon() {
  return (
    <>
      <path
        id='Vector'
        d='M11.668 15L11.668 1.33594M11.668 1.33594L14.5 4.16797M11.668 1.33594L8.83594 4.16797'
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_2'
        d='M4.66797 1.33594L4.66797 15M4.66797 15L7.5 12.168M4.66797 15L1.83594 12.168'
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  );
}
